export const getLinkTypeName = (serviceType) => {
  switch (serviceType) {
    case 'google':
      return 'Google'
    case 'yelp':
      return 'Yelp'
    case 'apartments':
      return 'Apartments.com'
    case 'apartmentratings':
      return 'Apartment Ratings'
    case 'facebook':
      return 'Facebook'
    default:
      return null
  }
}

export const getServiceTypeIcon = (serviceType) => {
  switch (serviceType) {
    case 'google':
      return '/images/socials/google-icon.png'
    case 'yelp':
      return '/images/socials/yelp-icon.png'
    case 'apartments':
      return '/images/socials/apartments-icon.png'
    case 'apartmentratings':
      return '/images/socials/raitings-icon.png'
    case 'facebook':
      return '/images/socials/facebook-icon.png'
    default:
      return null
  }
}

export const serviceOptions = [
  { id: 0, value: 'google', label: 'Google', iconPng: '/images/socials/google-icon.png' },
  {
    id: 1,
    value: 'apartments',
    label: 'Apartments.com',
    iconPng: '/images/socials/apartments-icon.png',
  },
  { id: 2, value: 'yelp', label: 'Yelp', iconPng: '/images/socials/yelp-icon.png' },
  {
    id: 3,
    value: 'apartmentratings',
    label: 'Apartment Ratings',
    iconPng: '/images/socials/raitings-icon.png',
  },
  { id: 4, value: 'facebook', label: 'Facebook', iconPng: '/images/socials/facebook-icon.png' },
]

export const platformInfo = {
  google: {
    label: 'Google',
    iconPng: '/images/socials/google-icon.png',
    allowMultipleReplies: false,
    allowEditingReplies: true,
  },
  apartments: {
    label: 'Apartments.com',
    iconPng: '/images/socials/apartments-icon.png',
    allowMultipleReplies: true,
    allowEditingReplies: false,
  },
}
